<template>
    <div class="sentence_back" :style="{backgroundColor:getCourseMainColor(courseId)}">
        <HeaderNav v-if="!isWeixinBrowser()" :navtitle="lessonTitle" :beforecolor="'#fff'" :backcolor="getCourseMainColor(courseId)" @returnBack="goToBack"></HeaderNav>
        <!--        <div class="sentence_title">-->
        <!--            {{lessonTitle}}-->
        <!--        </div>-->
        <div v-if="noShowGuideSlideCard == 0" class='popContainer' @click="guideSlideCardClick"><img src="../../../assets/single_sentence.png"/></div>
        <div class="lateral-sliding">
            <div class="lateral-sliding-item" v-for="(item,index) in sentenceIndexs" :key="index">
                <img :id="'startitle_' + (index + 1)" :src="showIndexImage(index + 1, item.finish)"
                     :style="{'margin-left': computeMargin(index, 1), 'margin-right': computeMargin(index, 0)}"
                     height="40" width="40" @click="indexSelectClick(index)">
            </div>
        </div>
        <Swiper v-if="wordCards.length > 0" ref="swiper" :autoPlay="false" :showIndicator="false"
                @transtionend="getNum" :style="{'margin-bottom': '60px'}" @observer="true" @observeParents="true">
            <Slide v-for="(item,index) in wordCards" :key="index">
                <div class="main_content">
                    <img class="img_show" v-lazy="$qiNiuDomainBase + item.positivePicture"
                         @click="playAudio(item.audio)">
                    <div class="audio_playing img_play" :style="{display: isPlaying ? '' : 'none'}"></div>
                    <img class="img_play" :style="{display: isPlaying ? 'none' : ''}"
                         src="@/assets/word_course_volume3.png" height="30" width="30"/>

                    <div class="page_num">
                        {{index + 1}} / {{wordCards.length}}
                    </div>

                    <div class="english_interpretation"
                         v-if="!isEmpty(item.englishInterpretation) || !isEmpty(item.sentenceChineseInterpretation) || getCount(item.displaySentenceGlossary) === 1"
                         @click="popupClick(index)">
                        <img src="@/assets/icon_english_english.png" height="15" width="15"/>
                        <span>{{interpretation(item.englishInterpretation, item.sentenceChineseInterpretation, item.displaySentenceGlossary)}}</span>
                    </div>
                </div>
            </Slide>
        </Swiper>

        <audio v-bind:src="audioUrl" id="musicMp3" @ended="playEnded" @error="playEnded" autoplay="autoplay" controls=""/>

        <mt-popup
            v-model="popupVisible"
            popup-transition="popup-fade"
            class="popup_style">
            <div v-if="!isEmpty(interpretationContent)" @click="closePopup">
                <pre>{{interpretationContent}}</pre>
            </div>
            <div class="glossary_list" v-if="glossarys !== null && glossarys.length > 0" @click="closePopup">
                <div class="word_card_item" v-for="(wordCard, index) in glossarys" :key="index"
                     @click="wordClick(wordCard.youdaoUrl, wordCard.pk, wordCard.word)">
                    <div class="word" v-bind:style="{color:isEmpty(wordCard.youdaoUrl) ? '#ff5050' : '#333333'}">
                        {{wordCard.word}}
                    </div>
                    <div class="example">{{wordCard.translation}}</div>
                    <div class="card_in">{{!isEmpty(wordCard.youdaoUrl) ? "详细释义 >" : "词卡 >"}}</div>
                </div>
                <div class="clear"></div>
            </div>
        </mt-popup>

        <div class="sentence_sound_recording" :style="{position: judgePlatform() === 3 || judgePlatform() === 4 ? 'fixed' : 'relative'}">
            <div class="audio_record_anim recording" :style="{display: isRecording ? '' : 'none'}" @click="endRecording"></div>
            <div v-if="noShowGuideRecord == 0" class="bubbleContainer" @click="guideRecordClick">
                <div class="text">点这里录音</div>
                <div class="img"><img src="../../../assets/arrow_drop_right.png"/></div>
            </div>
            <div class="recording" :style="{display: isRecording ? 'none' : ''}" @click="startRecording"><img src="../../../assets/icon_record_audio.png"/></div>
            <div class="playing" :style="{display: isEmpty(currentSentenceUrl) ? 'none' : ''}" @click="isPlayRecording ? playEnded() : playRecordAudio(currentSentenceUrl)">
                <img v-if="isPlayRecording" src="../../../assets/icon_pause.png">
                <img v-else src="../../../assets/icon_play.png"/></div>
        </div>
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk';
    import Vue from 'vue'
    import {Indicator, Toast} from "mint-ui";

    export default {
        name: "index",
        data() {
            return {
                courseId: 0,
                lessonId: 0,
                partNo: 0,
                sentenceIndex: 0,
                cardIndex: 0,
                lessonTitle: "",
                group: 0,
                groupName: "",
                sentenceIndexs: [],
                wordCards: [],
                screenWidth: document.body.clientWidth,
                audioUrl: "",
                interpretationContent: "",
                glossarys: [],
                popupVisible: false,
                isPlaying: false,
                isRecording: false,
                isPlayRecording: false,
                tiemr: null,
                currentSentenceUrl: "",
                noShowGuideSlideCard:1,
                noShowGuideRecord:1,
            }
        },
        mounted() {
            window.startCountDown = this.startCountDown;
        },
        methods: {
            isWeixinBrowser:function() {
                var ua = navigator.userAgent.toLowerCase();
                if(ua.match(/MicroMessenger/i)=="micromessenger") {
                    return true;
                }else if(typeof WeixinJSBridge !== "undefined"){
                    return true;
                }else {
                    return false;
                }
            },
            judgePlatform:function() {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if(!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            goToBack() {
                this.goBack(this.$router);
            },
            guideSlideCardClick:function(){
                let that = this;

                if (that.noShowGuideSlideCard === 1) {
                    return;
                }

                that.$axios.get("240words/saveGuidePrompt/key2").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideSlideCard = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            guideRecordClick:function() {
                let that = this;

                if (that.noShowGuideRecord === 1) {
                    return;
                }

                that.$axios.get("240words/saveGuidePrompt/key3").then((response) => {
                    let vResult = that.getCount(response.data);

                    if (vResult === 1) {
                        that.noShowGuideRecord = 1;
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            suspendRecord(){
                let that = this;

                if (!that.isRecording) {
                    return;
                }

                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];
                that.isRecording = false;

                if (vPlatform === 1 || vPlatform === 2) {
                    // 终止录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("终止录音: 微信平台");

                    // 停止录音
                    that.isCountDowning = false;
                    wx.stopRecord({});
                } else if(vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("终止录音: IOS平台");

                    let vUrl = "readingclubapp:suspendRecord:" + wordCard.pk + ":" + 1;
                    document.location = vUrl;
                } else if(vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("终止录音: android平台");

                    window.note.suspendRecord(parseInt(wordCard.pk), 1);
                } else {
                    window.console.log("终止录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            startRecording() {
                let that = this;

                if (that.isRecording) {
                    return;
                }

                // 关闭引导页
                that.guideRecordClick();
                that.playEnded();
                let wordCard = that.wordCards[that.cardIndex];
                let vWordsPartSentence = that.sentenceIndexs[that.sentenceIndex - 1];
                let vPlatform = that.judgePlatform();
                let second = this.isEmpty(wordCard.word) ? 15 : 5;

                if (vPlatform === 1 || vPlatform === 2) {
                    // 开启录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("开启录音: 微信平台");

                    wx.startRecord({
                        success: function(res) {
                            window.console.log(JSON.stringify(res));
                            that.isRecording = true;
                            that.startCountDown();
                        },
                        fail: function(res) {
                            window.console.log(JSON.stringify(res));
                            Toast('录音开启失败');
                        }
                    });
                } else if(vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("开启录音: IOS平台");

                    let vUrl = "readingclubapp:startRecord:" + wordCard.pk + ":" + 1 + ":" + second + ":" + vWordsPartSentence.pk;
                    document.location = vUrl;
                } else if(vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("开启录音: android平台");

                    window.note.startRecord(parseInt(wordCard.pk), 1, parseInt(second), parseInt(vWordsPartSentence.pk));
                } else {
                    window.console.log("开启录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            sentenceStartRecordAnimation() {
                this.isRecording = true;
            },
            sentenceEndRecordAnimation() {
                this.isRecording = false;
                Indicator.open('上传中...');
            },
            sentenceCloseIndicator() {
                Indicator.close();
            },
            endRecording() {
                let that = this;
                that.isCountDowning = false;
                that.isRecording = false;
                let vPlatform = that.judgePlatform();
                let wordCard = that.wordCards[that.cardIndex];
                let vWordsPartSentence = that.sentenceIndexs[that.sentenceIndex - 1];

                if (vPlatform === 1 || vPlatform === 2) {
                    // 关闭录音(1-微信IOS平台 2-微信android平台)
                    window.console.log("关闭录音: 微信平台");

                    // 停止录音
                    wx.stopRecord({
                        success: function(res) {
                            Indicator.open('上传中...');
                            window.console.log("停止录音：" + JSON.stringify(res));

                            // 上传音频到微信服务器
                            wx.uploadVoice({
                                localId: res.localId,
                                isShowProgressTips: 0,
                                success: function(uploadRes) {
                                    window.console.log(JSON.stringify(uploadRes));
                                    // 上传音频到其谬服务器
                                    that.saveUserAudio(uploadRes.serverId, uploadRes.localId, wordCard.pk, vWordsPartSentence.pk);
                                },
                                fail: function(uploadRes) {
                                    window.console.log(JSON.stringify(uploadRes));
                                    Indicator.close();
                                    Toast('录音上传失败');
                                }
                            });
                        },
                        fail: function(res) {
                            window.console.log(JSON.stringify(res));
                            Toast('录音停止失败');
                        }
                    });
                } else if(vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("关闭录音: IOS平台");

                    let vUrl = "readingclubapp:stopRecord:" + wordCard.pk + ":" + 1;
                    document.location = vUrl;
                } else if(vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("关闭录音: android平台");

                    window.note.stopRecord(parseInt(wordCard.pk), 1);
                } else {
                    window.console.log("关闭录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            saveUserAudio(mediaId, localId, cardId, sentenceId) {
                let that = this;
                let wordCard = that.wordCards[that.cardIndex];
                let url = "240words/sentenceWordRecording/";

                that.$axios.post(url,
                    {pk: wordCard.pk, mediaId: mediaId})
                    .then((response)=>{
                        window.console.log("录音保存七牛：" + JSON.stringify(response.data));
                        Indicator.close();

                        if (response.data != null  && response.data.code != -1) {
                            if (that.getCount(response.data.code) === 1) {
                                window.LessonRefreshData = 1;
                            }

                            that.wordCards.forEach((item, index) => {
                                if (cardId === item.pk) {
                                    item.userAudio = response.data.audio;
                                    Vue.set(that.wordCards, index, item);
                                }
                            });

                            that.sentenceIndexs.forEach((item, index) => {
                                if (sentenceId === item.pk) {
                                    item.finish = response.data.code;
                                    Vue.set(that.sentenceIndexs, index, item);
                                }
                            });

                            that.playRecordAudio2(response.data.audio, mediaId, false);

                            // 播放监听
                            wx.onVoicePlayEnd({
                                complete: function(res) {
                                    window.console.log("播放完成：" + JSON.stringify(res));
                                    that.playEnded();
                                }
                            });

                            // 播放录音
                            wx.playVoice({
                                localId: localId
                            });
                        } else {
                            Toast('录音上传失败');
                        }
                    });
            },
            startCountDown() {
                let that = this;
                let wordCard = that.wordCards[that.cardIndex];
                let second = this.isEmpty(wordCard.word) ? 15 : 5;
                this.isCountDowning = true;
                that.codeCountDown(second);
            },
            codeCountDown(second) {
                let that = this;
                let time = setTimeout(() => {
                    if (!this.isCountDowning) {
                        clearTimeout(time);
                        return;
                    }

                    clearTimeout(time);
                    that.endRecording();
                }, second*1000);
            },
            interpretation(english, chinese, glossary) {
                if (!this.isEmpty(english)) {
                    return "中英解释";
                }

                if (!this.isEmpty(chinese)) {
                    return "中文解释";
                }

                if (parseInt(glossary) === 1) {
                    return "本句生词";
                }

                return "";
            },
            popupClick(index) {
                let cardItem = this.wordCards[index];

                if (!this.isEmpty(cardItem.englishInterpretation)) {
                    this.glossarys = [];
                    this.interpretationContent = cardItem.englishInterpretation;
                    this.popupVisible = true;
                    return;
                }

                if (!this.isEmpty(cardItem.sentenceChineseInterpretation)) {
                    this.glossarys = [];
                    this.interpretationContent = cardItem.sentenceChineseInterpretation;
                    this.popupVisible = true;
                    return;
                }

                if (this.getCount(cardItem.displaySentenceGlossary) === 1) {
                    let indexItem = this.sentenceIndexs[cardItem.sentenceNo - 1];
                    // 展示生词
                    this.interpretationContent = "";
                    let url = "240words/getGlossaryInSentence/" + indexItem.pk;

                    this.$axios.get(url).then((response) => {
                        this.glossarys = response.data;
                        this.popupVisible = true;
                    });
                }
            },
            closePopup:function() {
                this.popupVisible = false;
            },
            wordClick: function (youdaoUrl, pk, word) {
                if (!this.isEmpty(youdaoUrl)) {
                    this.$router.push({name: 'pageView', query: {url: "https://m.youdao.com/dict?le=eng&q=" + word}});
                } else {
                    this.$router.push({
                        name: 'wordCard', query: {courseId: this.courseId, wordId: pk, word: word}
                    });
                }
            },
            showIndexImage(index, finish) {
                let vFinish = parseInt(this.getCount(finish));
                let imgUrl = (vFinish === 1 ? "star_sentence" : "star_sentence_un") + index + ".png";

                if (this.sentenceIndex === index) {
                    imgUrl = (vFinish === 1 ? "star_sentence_select" : "star_sentence_un_select") + index + ".png";
                }

                return require("@/pages/240words/240SingleSentence/images/" + imgUrl);
            },
            indexSelectClick(index) {
                this.sentenceIndex = index + 1;

                let that = this;

                if (index < that.sentenceIndexs.length) {
                    let indexItem = that.sentenceIndexs[index];
                    that.$refs.swiper.slideTo(parseInt(indexItem.startPosition));
                }
            },
            computeMargin(index, left) {
                let indexCount = parseInt(this.getCount(this.sentenceIndexs.length));

                if (indexCount === 0) {
                    return "";
                }

                var padding = 20;

                if (this.screenWidth < 440 && indexCount > 6) {
                    padding = (this.screenWidth - 260) / 7;
                } else {
                    padding = (this.screenWidth - 40 * indexCount) / (indexCount + 1);
                }

                if (left === 1) {
                    return index === 0 ? padding + "px" : "0px";
                }

                return padding + "px";
            },
            playAudio(audio) {
                let that = this;
                that.suspendRecord();
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlaying) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                that.isPlaying = true;
                that.isPlayRecording = false;
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            that.isPlaying = false;
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    that.isPlaying = false;
                    window.console.log("播放失败:playAudio");
                }
            },
            playEnded() {
                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();
                this.isPlayRecording = false;
                this.isPlaying = false;
            },
            sentencePlayRecordAudio(audio, finish, wordCardId, sentenceId) {
                // 句子完成
                let that = this;

                if (that.getCount(finish) === 1) {
                    window.LessonRefreshData = 1;
                }

                that.wordCards.forEach((item, index) => {
                    if (wordCardId === item.pk) {
                    item.userAudio = audio;
                    Vue.set(that.wordCards, index, item);
                    }
                });

                that.sentenceIndexs.forEach((item, index) => {
                    if (sentenceId === item.pk) {
                        item.finish = finish;
                        Vue.set(that.sentenceIndexs, index, item);
                    }
                });

                let wordCard = that.wordCards[that.cardIndex];
                let vPlatform = that.judgePlatform();

                if (wordCardId === wordCard.pk) {
                    // 非IOS平台录音完成字段播放，无需调用播放函数
                    that.playRecordAudio2(audio, "", vPlatform !== 3);
                }
            },
            playRecordAudio(audio) {
                this.playRecordAudio2(audio, "", false);
            },
            playRecordAudio2(audio, wxMediaId, autoPlay) {
                let that = this;
                let musicMp3 = document.getElementById('musicMp3');

                if (that.isPlayRecording) {
                    musicMp3.pause();
                }

                that.audioUrl = that.$qiNiuDomainBase + audio;
                that.currentSentenceUrl = audio;
                that.isPlaying = false;
                that.isPlayRecording = true;

                if (!autoPlay && that.isEmpty(wxMediaId)) {
                    let playPromise = musicMp3.play();

                    if (playPromise !== undefined) {
                        playPromise.catch((e) => {
                            that.isPlayRecording = false;
                            window.console.log("播放失败:playRecordAudio2:" + e);
                        })
                    } else {
                        that.isPlayRecording = false;
                        window.console.log("播放失败:playRecordAudio2");
                    }
                }
            },
            getNum(data) {
                let that = this;

                //输出轮播到第几张图片
                if (data < that.wordCards.length) {
                    that.cardIndex = data;
                    let wordItem = that.wordCards[data];
                    that.playAudio(wordItem.audio);
                    that.sentenceIndex = wordItem.sentenceNo;
                    that.currentSentenceUrl = wordItem.userAudio;
                    document.getElementById("startitle_" + that.sentenceIndex).scrollIntoView();
                }
            },
            wxRecordConfig(data) {
                let appId = data.appId;
                let timestamp = data.timestamp;
                let nonceStr = data.nonceStr;
                let signature = data.signature;

                wx.config({
                    debug: false,
                    appId: appId,
                    timestamp: timestamp,
                    nonceStr: nonceStr,
                    signature: signature,
                    jsApiList: [
                        'startRecord',
                        'stopRecord',
                        'onVoiceRecordEnd',
                        'playVoice',
                        'onVoicePlayEnd',
                        'pauseVoice',
                        'stopVoice',
                        'uploadVoice',
                        'downloadVoice',
                        'uploadImage']
                });
            }
        },
        created() {
            let that = this;
            // 客户端调用方法组
            window.sentenceStartRecordAnimation = that.sentenceStartRecordAnimation;
            window.sentenceEndRecordAnimation = that.sentenceEndRecordAnimation;
            window.sentencePlayRecordAudio = that.sentencePlayRecordAudio;
            window.sentenceCloseIndicator = that.sentenceCloseIndicator;

            // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
            if (that.isWeixinBrowser()) {
                this.$axios.post("fwh/getSignature", {
                    url: that.judgePlatform() === 1 ? window.location.protocol + "//" + window.location.host + "/" : window.location.href
                }).then((response) => {
                    that.wxRecordConfig(response.data);
                });
            }
        },
        beforeCreate() {
            let vCourseId = parseInt(this.$route.query.courseId);
            let vlessonId = parseInt(this.$route.query.lessonId);
            let vPartNo = parseInt(this.$route.query.partNo);
            let vSentenceIndex = parseInt(this.$route.query.sentenceIndex);
            let vLessonTitle = this.$route.query.lessonTitle;
            let vGroup = parseInt(this.$route.query.group);
            let vGroupName = this.$route.query.groupName;
            let url = "240words/getPartSentenceInfo2/" + vlessonId + "/" + vPartNo + "/" + vGroup;
            let that = this;

            this.$axios.get(url).then((response) => {
                that.sentenceIndexs = response.data;
                that.courseId = vCourseId;
                that.lessonId = vlessonId;
                that.partNo = vPartNo;
                that.sentenceIndex = vSentenceIndex;
                that.lessonTitle = vLessonTitle;
                that.group = vGroup;
                that.groupName = vGroupName;

                var startPosition = 0;

                that.sentenceIndexs.forEach((item, index) => {
                    item.wordCardArray.forEach((cardItem, cardIndex) => {
                        if (vSentenceIndex === index + 1 && cardIndex === 0) {
                            that.audioUrl = that.$qiNiuDomainBase + cardItem.audio;
                            that.currentSentenceUrl = cardItem.userAudio;
                            that.cardIndex = startPosition;
                        }

                        that.wordCards.push(cardItem);
                    });

                    item.startPosition = startPosition;
                    Vue.set(that.sentenceIndexs, index, item);
                    startPosition += item.wordCardArray.length;
                });

                this.$nextTick(function() {
                    that.$refs.swiper.slideTo(parseInt(that.cardIndex));
                    that.isPlaying = true;
                    window.LessonRefreshData = 0;
                });

                if(!that.isEmpty(that.sentenceIndexs)) {
                    let objWordsPartSentenceItem = that.sentenceIndexs[0];
                    that.noShowGuideSlideCard = that.getCount(objWordsPartSentenceItem.key2);
                    that.noShowGuideRecord = that.getCount(objWordsPartSentenceItem.key3);
                }
            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    .sentence_back {
        position: absolute;
        width: 100%;
        height: auto;
        min-height: 100%;
    }

    .sentence_title {
        text-align: center;
        font-size: 17px;
        color: white;
        margin-top: 15px;
    }

    .lateral-sliding {
        display: flex;
        overflow-y: hidden;
        overflow-x: scroll;
        margin-top: 15px;
    }

    div ::-webkit-scrollbar {
        display: none;
    }

    .lateral-sliding-item {
        display: flex;
    }

    .lateral-sliding-item img {
        margin-right: 20px;
    }

    .main_content {
        max-width: 560px;
        width: 100%;
        position: relative;
        left: 50%;
        -webkit-transform: translateX(-50%);
        margin-top: 30px;
    }

    .main_content .img_show {
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
        width: calc(100% - 60px);
        margin: auto;
    }

    .main_content .img_play {
        position: absolute;
        right: 45px;
        top: 15px;
    }

    audio {
        display: none;
    }

    .main_content .page_num {
        margin-top: 10px;
        color: white;
        text-align: center;
        font-size: 17px;
    }

    .english_interpretation {
        position: absolute;
        right: 0px;
        margin-top: 10px;
        bottom: 2px;
    }

    .english_interpretation img {
        float: left;
        margin-top: 4px;
        margin-right: 5px;
    }

    .english_interpretation span {
        color: white;
        padding-right: 30px;
    }

    .popup_style {
        width: calc(100% - 60px);
        padding-left: 15px;
        padding-right: 15px;
        padding-top: 20px;
        padding-bottom: 20px;
        margin-right: 30px;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }

    .popup_style pre {
        text-align: left;
        font-size: 20px;
        font-weight: bold;
        white-space: pre-wrap; /* css-3 */
        white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
    }

    .glossary_list {
        margin-top: 20px;
        margin-left: 7px;
        margin-right: 8px;
    }

    .glossary_list .word_card_item {
        background-color: white;
        width: calc((100% - 30px) / 2);
        margin-left: 8px;
        margin-right: 7px;
        border-radius: 6px;
        -webkit-border-radius: 6px;
        -moz-border-radius: 6px;
        margin-bottom: 15px;
        float: left;
        -webkit-box-shadow: #666 0 0 0.15rem;
        -moz-box-shadow: #666 0 0 0.15rem;
        box-shadow: #666 0 0 0.15rem;
    }

    .glossary_list .word_card_item .word {
        margin-top: 15px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
    }

    .glossary_list .word_card_item .example {
        text-align: center;
        font-size: 17px;
        color: #333333;
        margin-top: 15px;
    }

    .glossary_list .word_card_item .card_in {
        text-align: center;
        font-size: 15px;
        color: #999999;
        margin-top: 5px;
        margin-bottom: 15px;
    }

    .sentence_sound_recording {
        width: 100%;
        height: 70px;
        bottom: 20px;
    }

    .sentence_sound_recording .recording {
        position: absolute;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }

    .sentence_sound_recording .recording img {
        width: 70px;
        height: 70px;
    }

    .sentence_sound_recording .playing {
        position: absolute;
        right: 20px;
        top: 50%;
        -webkit-transform: translateY(-50%);
    }

    .sentence_sound_recording .playing img {
        width: 35px;
        height: 35px;
    }

    .audio_record_anim {
        width: 70px; /*宽高尺寸任意增减*/
        height: 70px;
        background: url(../../../assets/record_audio_anim.png) no-repeat;
        background-size: 1000% 100%;
        -webkit-animation: line-slow 0.8s steps(9) infinite;
        animation: line-slow 0.8s steps(9) infinite;
    }

    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }
    .popContainer {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
    }
    .popContainer img{
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
        width:70%;
        max-width: 400px;
    }
    .bubbleContainer{
        position: absolute;
        left: calc(50% - 99px);
        bottom: 21.5px;
        -webkit-transform: translateX(calc(50% - 99px));
    }
    .bubbleContainer .text {
        display:inline-block;
        color: #333333;
        background-color: white;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        padding: 3px 15px 3px 15px;
        font-size: 15px;
        font-weight: bold;
    }
    .bubbleContainer .img {
        position: absolute;
        top: 5px;
        right: -9px;
        display:inline-block;
        width: 15px;
    }
    .bubbleContainer .img img {
        width: 15px;
    }
</style>
